var map = {
  "./agent.js": "59813",
  "./auth.js": "48880",
  "./common.js": "17695",
  "./content.js": "72665",
  "./demo.js": "1269",
  "./diy.js": "81562",
  "./goods.js": "9518",
  "./marketing.js": "9040",
  "./order.js": "77352",
  "./system.js": "7255",
  "./test.js": "53562",
  "./user.js": "94729"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 96968;
